export const HomeLayoutColumns: { [P in string]: number } = {
  lg: 14,
  md: 10,
  sm: 6,
  xs: 4,
  xxs: 2,
};
export const HomeLayoutBreakpoints: { [P in string]: number } = {
  lg: 1600,
  md: 1100,
  sm: 768,
  xs: 480,
  xxs: 0,
};
